import React, {useEffect} from 'react';
import {AutoComplete, Button, Form, Input, InputNumber, message, Select, Upload} from "antd";
import TextArea from "antd/es/input/TextArea";
import {UploadOutlined} from "@ant-design/icons";
import {Auth} from "@digatex/digatex-ui-lib";
import {DatePicker, } from "antd";
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
const { Option } = Select;

export function StandardForm({form, fields, onFinish, initialValues, onFieldsChange}) {



    const getInputByType = item => {

        const props = {
            action: item.action,
            headers: item.headers,
            beforeUpload: (file) => {
                const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                if (!isExcel) {
                    message.error(`${file.name} is not an Excel file`);
                }
                return isExcel || Upload.LIST_IGNORE;
            },
        };

        switch (item._type) {
            case 'number': return <InputNumber style={{width: '50%'}} />
            case 'file': return <Upload {...props}>
                <Button icon={<UploadOutlined />}>Upload Excel files only</Button>
            </Upload>
            case 'date': return <DatePicker defaultValue={dayjs()}/>
            case 'long_text': return <TextArea />
            case 'select': return       <Select
                placeholder="Select an option"
                allowClear
            >
                {item.options.map((opt, key) => <Option key={key} value={opt}>{opt}</Option>)}
            </Select>
            case 'select-object': return       <Select
                placeholder="Select an option"
                allowClear
                options={item.options}
            >
            </Select>
            case 'autocomplete': return       <AutoComplete
                options={item.options.map(o => {
                    return {
                        'value': o,
                        'label': String(o)
                    }
                })}
                filterOption={(inputValue, option) =>
                    option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                placeholder="Select value"
            />
            default: return <Input />
        }
    }

    return <Form
        onFieldsChange={onFieldsChange}
            onFinish={onFinish}
            form={form}
            initialValues={{...initialValues}}
            id="editForm"
        >
            {fields.map ((v,i) => <Form.Item
                key={i}
                label={<b>{v.label}</b>}
                name={v.name}
                rules={[
                    {
                        required: v.required,
                        message: v.message,
                    },
                ]}
            >
                {getInputByType(v)}
            </Form.Item>)}
        </Form>

}
